import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useState } from "react";
import { Icon } from "@mui/material";

import { closeVideoPlayerModal } from 'Redux/actions';
import "./videoPlayer.scss";

const VideoPlayer = () => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { openModal, urls, currentVideoIndex, title } = useSelector(state => state.videoPlayerRedux);
    const [selectedIndex, setSelectedIndex] = useState(currentVideoIndex || 0);

    const currentUrl = urls && urls.length > 0 ? urls[selectedIndex] : null;

    const handleClose = () => {
        dispatch(closeVideoPlayerModal());
    };

    return (
        <Modal
            open={openModal}
            title={title || messages['video_player_title']}
            position="right"
            size="medium"
            handleClose={handleClose}
        >
            <ModalBody style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '12px', overflow: 'auto' }}>
                <div className="video-player-container" style={{ minHeight: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {currentUrl && (
                        <video
                            key={selectedIndex}
                            src={currentUrl}
                            controls
                            autoPlay
                            controlsList="nodownload"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '280px',
                                backgroundColor: '#000',
                                borderRadius: '4px'
                            }}
                        />
                    )}
                </div>

                {urls && urls.length > 1 && (
                    <div className="video-list-container">
                        <div className="video-list-header">
                            <span>{selectedIndex + 1} / {urls.length} Videos</span>
                        </div>

                        <div className="video-list-vertical">
                            {urls.map((url, index) => (
                                <div
                                    key={index}
                                    className={`video-list-item-vertical ${selectedIndex === index ? 'active' : ''}`}
                                    onClick={() => setSelectedIndex(index)}
                                >
                                    <div className="video-thumb-vertical">
                                        <Icon>play_circle_filled</Icon>
                                    </div>
                                    <div className="video-info">
                                        <span className="video-label">Video {index + 1}</span>
                                        {selectedIndex === index && <span className="video-selected">(actual)</span>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={handleClose}
                >
                    {messages['common_cancel']}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default VideoPlayer;
